import * as def from '@/definitions'
import { Layer } from './layer';
import { ObjectLayer } from './objectLayer';
import { UuidHelper } from '@/helper/uuidHelper';

// QRコードレイヤー
export class QRcodeLayer extends ObjectLayer
{
    public get layerType() : string { return "qrcode"; }

    // 入力文字
    private _text : string = "";
    public get text() { return this._text; }
    public set text(text) { this._text = text; }

    // マージン
    private _margin : boolean = true;
    public get margin() { return this._margin; }
    public set margin(margin) { this._margin = margin; }

    // 誤り訂正
    // 0: L
    // 1: M
    // 2: Q
    // 3: H
    private _errorCorrection : number = 1;
    public get errorCorrection() { return this._errorCorrection; }
    public set errorCorrection(errorCorrection) { this._errorCorrection = errorCorrection; }

    // バージョン(0:指定なし, 1~40)
    private _version : number = 0;
    public get version() { return this._version; }
    public set version(version) { this._version = version; }

    // 作成
    public static create(text : string, x : number = 0, y : number = 0, width : number = 0, height : number = 0) : QRcodeLayer
    {
        var layer = new QRcodeLayer();
        layer.width = width;
        layer.height = height;
        layer.x = x;
        layer.y = y;
        layer.text = text;
        layer.insertionId = UuidHelper.getUuid();

        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new QRcodeLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : QRcodeLayer)
    {
        layer.text = this._text;
        layer.margin = this._margin;
        layer.errorCorrection = this._errorCorrection;
        layer.version = this._version;
        
        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.text = this._text;
        jsonObject.margin = this._margin;
        jsonObject.errorCorrection = this._errorCorrection;
        jsonObject.version = this._version;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : QRcodeLayer
    {
        var layer = new QRcodeLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.text != null) { this._text = jsonData.text; }
        if(jsonData.margin != null) { this._margin = jsonData.margin; }
        if(jsonData.errorCorrection != null) { this._errorCorrection = jsonData.errorCorrection; }
        if(jsonData.version != null) { this._version = jsonData.version; }

        super.loadParameterFromJson(jsonData);
    }
}